import { httpRequest } from "../../../utils/HttpRequest";
import { IKey, IPage, ISearchPage } from "../../../types/ScmTypes";

export interface IStockStatisticFields {
    id?: string,              //"库存ID",
    materialCode?: string,              //"配件编码",
    materialName?: string,              //"配件名称",
    typeCode?: string,              // "商品类型",
    typeName?: string,              //"商品类型名称",
    replaceCode?: string,              // "替换编号",
    unit?: string,              // "单位",
    warehousecode?: string,              // "仓库code",
    warehouseName?: string,              // "仓库名称",
    shelfId?: string,              // "货位ID",
    shelfCode?: string | null,              // "货位编号",
    inventoryNum?: number,              // "库存数",
    brandCode?: string,              //"商品品牌",
    brandName?: string,              //"品牌名称",
    model?: string,              //"规格型号",
    averagePurchasePrice?: number,              //"平均进价",
    averageAmount?: number,              //"平均库存成本",
    latestPurPrice?: number,              //"最近进货价",
    latestAmount?: number,              //"最近库存成本",
    lateSalePrice?: number,              //"最近销价",
    limitUpper?: number,              //"库存上限",
    limitLower?: number,              //"库存下限",
    warehouseCode?: string,
    isEqual?: string,
    age?: number | boolean,
    [key: string]: any

}
export type IInventoryTotal = {
    averageAmount: number, // 877273.46
    latestAmountTotal: number, // 877273.46
    total: number, // 1919
    type: number, // 23
}
export type IList = {
    current: number
    hitCount: boolean
    isSearchCount: boolean
    optimizeCountSql: boolean
    orders: any
    records: IStockStatisticFields[]
    size: number
    total: number
}
export type IStockStatisticDetails = {
    inventoryTotal: IInventoryTotal,
    list: IList
}
export type IStockStatisticSearch = IStockStatisticFields & ISearchPage;
export type IStockStatisticDetail = IStockStatisticFields;

export interface IStockStatisticSonFields {
    id?: string,          // "9d0510aecfec4876a1f5c9b1f60b2ac1",
    stockInId?: string,          // "ab3288727ebc485b8b24421a874a6a8d",
    tradeCode?: string,          // "CG20210129040",
    tradeTypeCode?: string,          // "trade-type.purchase",
    tradeTypeName?: string,          // "采购单",
    materialCode?: string,          // "123",
    materialName?: string,          // "干燥罐",
    replaceCode?: string,          // "s001",
    price?: string,          // 100,
    num?: string,          // 19,
    discountRate?: string,          // 0,
    amount?: string,          // 1900,
    warehouseCode?: string,          // "sa003",
    warehouseName?: string,          // "沙特海外B库",
    shelfId?: string,          // "085a638c7e202b1b12aa08f02de5c393",
    shelfCode?: string,          // "sa0031",
    createUser?: string,          // null,
    ioFlag?: string,          // 1
    materialNameEn?: string,          // "干燥罐",

}
export type IStockStatisticSonSearch = IStockStatisticSonFields & ISearchPage;
export type IStockStatisticSonDetail = IStockStatisticSonFields
class StockStatisticService {
    async page(params: IStockStatisticSearch) {
        const apiUrl = "/vrm-sa/stock/findPages";
        return await httpRequest.post<IPage<IStockStatisticDetail>>(apiUrl, params);
    }
    async pages(params: IStockStatisticSearch) {
        const apiUrl = "/vrm-sa/stock/findPage";
        return await httpRequest.post<IStockStatisticDetails[]>(apiUrl, params);
    }
    async detailPage(params: IStockStatisticSearch) {
        const apiUrl = "/vrm-sa/stock/details/findPage";
        return await httpRequest.post<IPage<IStockStatisticSonDetail>>(apiUrl, params);
    }
    // 导出
    async export(params: IStockStatisticSearch) {
        const apiUrl = "/vrm-sa/stock/export";
        return await httpRequest.postFile(apiUrl, params,{ timeout: 600000 });
    }
}

export const stockStatisticService = new StockStatisticService();